import { AccordionItem } from 'Components/Accordion/AccordionItem/AccordionItem';
import { AccordionToggle } from 'Components/Accordion/AccordionToggle/AccordionToggle';

import styles from './ConfigurationRow.module.css';

export interface ConfigurationRowProps {
    level: 0 | 1 | 2 | 3;

    accessibilityTitle?: string;
    children?: React.ReactNode;
    eventKey?: string;
}

/**
 * An accordion row for the configuration of a due diligence assessment.
 * Supports 4 levels of indentation:
 * * Level 0: Control Framework
 * * Level 1: Control Group
 * * Level 2: Control
 * * Level 3: Question
 */
export const ConfigurationRow = (props: ConfigurationRowProps) => {
    const { eventKey, level, accessibilityTitle, children } = props;

    const getStyleClassArrow = (): string => {
        switch (level) {
            case 0:
                return styles.inlineStylesLevel0;
            case 1:
                return styles.inlineStylesLevel1;
            case 2:
                return styles.inlineStylesLevel2;
            case 3:
                return styles.inlineStylesLevel3;
        }
    };

    const getStyleClassNoArrow = (): string => {
        switch (level) {
            case 0:
                return styles.inlineStylesNoArrowLevel0;
            case 1:
                return styles.inlineStylesNoArrowLevel1;
            case 2:
                return styles.inlineStylesNoArrowLevel2;
            case 3:
                return styles.inlineStylesNoArrowLevel3;
            default:
                return '';
        }
    };

    if (eventKey && accessibilityTitle) {
        return (
            <AccordionItem eventKey={eventKey}>
                <div className={`${styles.row} ${getStyleClassArrow()}`}>
                    <AccordionToggle eventKey={eventKey} ariaLabelSuffix={accessibilityTitle} />
                    {children}
                </div>
                <hr className={styles.hrModifier} />
            </AccordionItem>
        );
    } else {
        return (
            <>
                <div className={`${styles.row} ${getStyleClassNoArrow()}`}>{children}</div>
                <hr className={styles.hrModifier} />
            </>
        );
    }
};
